import React from 'react';

const MachineHours = () => {
  return (
    <div data-testid="machine-hours-page">
      <div className="bg-card rounded-xl shadow-sm border border-border p-8">
        <h2 className="text-xl font-semibold mb-4">Maskintimmar</h2>
        <p className="text-muted-foreground">Global vy för alla maskintimmar visas här</p>
      </div>
    </div>
  );
};

export default MachineHours;
